class TmPhoneEl {
    static $instances = [];

    static instance(identifier) {
        return TmPhoneEl.$instances[identifier] ?? null;
    }

    static add(querySelector, identifier, forceUpdate = false) {
        if (querySelector && identifier.length > 0 && (!TmPhoneEl.instance(identifier) || forceUpdate)) {
            TmPhoneEl.$instances[identifier] = new TmPhoneEl(querySelector, identifier);
        }
        return TmPhoneEl.instance(identifier);
    }

    constructor(querySelector, identifier) {
        this.querySelector = querySelector;
        this.identifier = identifier;
        try {
            this.iti = window.intlTelInput(querySelector, {
                strictMode: true,
                initialCountry: 'us',
                containerClass: 'new-phone-input',
                nationalMode: true,
                separateDialCode: true,
                formatOnDisplay: true,
                formatAsYouType: true,
                useFullscreenPopup: false,
                countryOrder: ['us', 'au', 'ca', 'fr', 'de', 'ie', 'it', 'nl', 'nz', 'gb'],
                loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
            });

            this.querySelector.addEventListener("input", function () {
                this.updateClassForNumber();
            }.bind(this));

            this.querySelector.addEventListener("focus", function () {
                this.updateClassForNumber(true);
            }.bind(this));

            this.querySelector.addEventListener("blur", function () {
                this.updateClassForNumber();
            }.bind(this));

            this.querySelector.addEventListener("countrychange", () => {
                jQuery(document).trigger('tmPhoneEl_country_change___' + this.identifier, {countryData: this.iti.getSelectedCountryData()});
            });

            this.updateClassForNumber();
        } catch (e) {}
    }

    updateClassForNumber(isFocused = false) {
        if (this.querySelector.value.trim() || isFocused) {
            this.querySelector.classList.remove("empty");
            this.querySelector.closest(".iti").classList.add("number-entered");
            this.querySelector.removeAttribute('placeholder');
        }
        else {
            this.querySelector.classList.add("empty");
            this.querySelector.closest(".iti").classList.remove("number-entered");
        }
    }

    getNumber() {
        let number = '';
        try {
            number = this.iti.getNumber();
        } catch (e) {}
        return number;
    }

    setNumber(value) {
        try {
            this.iti.setNumber(value);
        } catch (e) {}
    }

    getFormattedNumber() {
        let number = '';
        try {
            let selectedCountryData = this.iti.getSelectedCountryData();
            number = intlTelInput.utils.formatNumber(
                this.iti.getNumber(),
                selectedCountryData.iso,
                'NATIONAL'
            );
            number = '+' + selectedCountryData.dialCode + ' ' + number;
        } catch (e) {}
        return number;
    }

    isValidNumber() {
        let isValid = false;
        try {
            isValid = this.iti.isValidNumber();
        } catch (e) {}
        return isValid;
    }
}
